import React from 'react';
import { useSelector } from 'react-redux';
import Tooltip from '../../../../../ui/tooltip/Tooltip';
import classes from './ProgressCell.module.css';

const ProgressCell = ({ value }) => {

    const { texts } = useSelector((state) => state.translate);

    return (
        // <Tooltip text={`${Number(value)} ${texts.progressTooltipParticipating} ???  ${texts.progressTooltipTotal}`} showTooltip>
            <div className={classes.progressCell}>
                {value}
            </div>
        // </Tooltip>
    );
};

export default ProgressCell;
